import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Registo do restaurante',
  description: 'Passo {{activeStep}} de {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Info básica',
    [Step.BusinessDetails]: 'Detalhes do negócio',
  },
  form: {
    name: {
      label: 'Nome do restaurante',
      placeholder: 'Introduza o nome do restaurante',
    },
    timezone: {
      label: 'Fuso horário',
      placeholder: 'Pesquisar cidade ou fuso horário',
      inference_failed: 'Não foi possível determinar o fuso horário a partir deste endereço — por favor selecione-o.',
    },
    google_place: {
      label: 'Local Google selecionado: {{name}}',
    },
    is_franchise: {
      label: 'O restaurante faz parte de uma marca',
    },
    sync_lieferando_brand: {
      label: 'Obter dados de marca (logótipo, cor principal) do Lieferando',
    },
    import_menu: {
      label: 'Importar menu',
    },
    lieferando_url: {
      label: 'URL do Lieferando',
      placeholder: 'URL do restaurante no Lieferando',
    },
    other_platforms: {
      label: 'Plataformas de entrega atuais',
      description: 'Selecione todas as plataformas onde está listado',
    },
    pos_system: {
      label: 'Sistema POS atual',
      placeholder: 'Selecione o seu sistema POS',
      options: {
        [PosSystems.Other]: 'Outro',
      },
    },
    delivery_mode: {
      label: 'Modo de entrega',
      placeholder: 'Selecione o modo de entrega',
      options: {
        [DeliveryMode.Internal]: 'Interno (estafetas próprios)',
        [DeliveryMode.External]: 'Externo (terceiros)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Vendas mensais de entregas',
      description: 'Total de vendas em todas as plataformas de entrega',
      placeholder: 'Selecione o intervalo de vendas',
      options: {
        other: 'Outro',
      },
      other: {
        placeholder: 'Introduza o valor de vendas',
      },
    },
    lead_source: {
      label: 'Origem do contacto',
      description: 'Como nos conheceu?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Prospeção por Representante de Desenvolvimento de Vendas',
        },
        [LeadSources.Inbound]: {
          title: 'Inbound',
          description: 'Chegou através do website ou marketing',
        },
        [LeadSources.Referral]: {
          title: 'Referência - Restaurante existente',
          description: 'Referenciado por um dos nossos restaurantes parceiros',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Auto-gerado - Frio',
          description: 'Encontrado por prospeção a frio',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Auto-gerado - Referência',
          description: 'Rede ou contacto pessoal',
        },
        [LeadSources.Tipster]: {
          title: 'Informador',
          description: 'Foodamigos paga uma comissão à pessoa/empresa X pela recomendação',
        },
      },
    },
    sdr: {
      description: 'Selecione o SDR responsável pela prospeção deste contacto',
    },
    has_instagram_profile: {
      label: 'Perfil de Instagram',
      description: 'O seu restaurante tem perfil no Instagram?',
      options: {
        true: 'Sim',
        false: 'Não',
      },
    },
  },
  buttons: {
    back: 'Voltar',
    next: 'Seguinte',
    complete_registration: 'Concluir registo',
  },
  basic_information: {
    title: 'Informação básica',
    description: 'Introduza os dados básicos e de contacto do restaurante',
  },
  additional_options: {
    title: 'Opções adicionais',
    description: 'Configure definições adicionais para este restaurante',
  },
  restaurant_type: {
    title: 'Tipo de restaurante e modelo de serviço',
    description: 'Escolha o formato que melhor descreve o estilo de serviço deste restaurante',
  },
  cuisine_type: {
    title: 'Categorias de comida e tipos de cozinha',
    description: 'Selecione todas as categorias e tipos de cozinha aplicáveis a este restaurante',
    placeholder: 'Pesquisar tipos de cozinha',
  },
  business_details: {
    title: 'Detalhes do negócio',
    description: 'Ajude-nos a compreender as suas operações atuais',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Restaurante de serviço completo',
      description: 'Refeições sentado com serviço de mesa',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description: 'Pedido ao balcão/app, maior qualidade e personalização que QSR, lugares opcionais',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Serviço rápido (QSR) / Takeaway',
      description: 'Serviço ao balcão rápido; principalmente takeaway',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Café e Padaria',
      description: 'Café, pastelaria, refeições ligeiras, pequeno-almoço/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Sobremesas e Gelados',
      description: 'Conceitos centrados em doces',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Bebidas e Bar',
      description: 'Locais focados em bebidas; comida opcional; entrega de álcool sujeita a regras locais',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Apenas entrega / Cozinha fantasma',
      description: 'Sem loja física; marcas virtuais e cozinhas cloud',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Hambúrgueres',
    [CuisineTypes.ChickenFried]: 'Frango frito',
    [CuisineTypes.Wings]: 'Asas',
    [CuisineTypes.KebabDoner]: 'Kebab/Doner',
    [CuisineTypes.Sandwiches]: 'Sandes',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Saladas',
    [CuisineTypes.Healthy]: 'Saudável',
    [CuisineTypes.Bowls]: 'Bowls',
    [CuisineTypes.Vegan]: 'Vegan',
    [CuisineTypes.Vegetarian]: 'Vegetariano',
    [CuisineTypes.GlutenFree]: 'Sem glúten',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japonesa',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Coreana',
    [CuisineTypes.KoreanFriedChicken]: 'Frango frito coreano',
    [CuisineTypes.Chinese]: 'Chinesa',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Cantonesa/Dim Sum',
    [CuisineTypes.Thai]: 'Tailandesa',
    [CuisineTypes.Vietnamese]: 'Vietnamita',
    [CuisineTypes.Malaysian]: 'Malaia',
    [CuisineTypes.Indonesian]: 'Indonésia',
    [CuisineTypes.Filipino]: 'Filipina',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indiano',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Paquistanês',
    [CuisineTypes.SriLankan]: 'Sri-lankês',
    [CuisineTypes.Nepalese]: 'Nepalês',

    [CuisineTypes.Turkish]: 'Turco',
    [CuisineTypes.Lebanese]: 'Libanês',
    [CuisineTypes.Syrian]: 'Sírio',
    [CuisineTypes.Israeli]: 'Israelita',
    [CuisineTypes.Egyptian]: 'Egípcio',
    [CuisineTypes.PersianIranian]: 'Persa/Iraniano',
    [CuisineTypes.Iraqi]: 'Iraquiano',
    [CuisineTypes.Afghan]: 'Afegão',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grelhados',
    [CuisineTypes.Greek]: 'Grego',
    [CuisineTypes.Mediterranean]: 'Mediterrâneo',

    [CuisineTypes.Italian]: 'Italiano',
    [CuisineTypes.Pasta]: 'Massa',
    [CuisineTypes.French]: 'Francês',
    [CuisineTypes.SpanishTapas]: 'Espanhol/Tapas',
    [CuisineTypes.Portuguese]: 'Português',
    [CuisineTypes.German]: 'Alemão',
    [CuisineTypes.Austrian]: 'Austríaco',
    [CuisineTypes.Balkan]: 'Balcânico',
    [CuisineTypes.Hungarian]: 'Húngaro',
    [CuisineTypes.Polish]: 'Polaco',
    [CuisineTypes.Czech]: 'Checo',
    [CuisineTypes.Georgian]: 'Georgiano',

    [CuisineTypes.Mexican]: 'Mexicano',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruano',
    [CuisineTypes.Brazilian]: 'Brasileiro',
    [CuisineTypes.Argentinian]: 'Argentino',
    [CuisineTypes.Caribbean]: 'Caribenho',
    [CuisineTypes.BBQAmerican]: 'BBQ/Americano',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'Americano (Geral)',
    [CuisineTypes.HotDogs]: 'Hot Dogs',

    [CuisineTypes.Seafood]: 'Marisco',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Peixe no Vapor',

    [CuisineTypes.BreakfastBrunch]: 'Pequeno-almoço/Brunch',
    [CuisineTypes.Bagels]: 'Bagels',
    [CuisineTypes.Bakery]: 'Padaria',
    [CuisineTypes.PastryDessert]: 'Pastelaria/Sobremesa',
    [CuisineTypes.WafflesCrepes]: 'Waffles/Crepes',
    [CuisineTypes.IceCreamGelato]: 'Gelado/Gelato',
    [CuisineTypes.Donuts]: 'Donuts',
    [CuisineTypes.Cakes]: 'Bolos',

    [CuisineTypes.CoffeeCafe]: 'Café',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Sumos/Smoothies',
    [CuisineTypes.Milkshakes]: 'Batidos',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Bar de Vinhos',
    [CuisineTypes.Cocktails]: 'Cocktails',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Pratos Pequenos',
    [CuisineTypes.Noodles]: 'Noodles',
    [CuisineTypes.Soup]: 'Sopa',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Street Food',
    [CuisineTypes.OrganicBio]: 'Orgânico/Bio',
    [CuisineTypes.KidsMenu]: 'Menu Infantil',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/Geral',
    [CuisineCategories.AsianPacific]: 'Asiático/Pacífico',
    [CuisineCategories.SouthAsian]: 'Sul-Asiático',
    [CuisineCategories.MiddleEastMediterranean]: 'Médio Oriente/Mediterrâneo',
    [CuisineCategories.Europe]: 'Europa',
    [CuisineCategories.Americas]: 'Américas',
    [CuisineCategories.SeafoodSpecialty]: 'Especialidade de Marisco',
    [CuisineCategories.BreakfastBakerySweets]: 'Padaria/Doces de Pequeno-almoço',
    [CuisineCategories.BeverageLed]: 'Focado em Bebidas',
    [CuisineCategories.OtherConcepts]: 'Outros Conceitos',
  },
};
